const translations = {
  ru: {
    header: {
      title: "Clases con Xenia",
      subtitle: "Планируйте занятия, управляйте расписанием, получайте уведомления и синхронизируйте уроки с Google Календарем.",
      login: "Войти",
      logout: "Выйти",
    },
    booking: {
      paymentTitle: "Ещё немного — и можно записаться",
      paymentDebt: (n) => n === 1 ? "В календаре пока есть 1 неоплаченный урок. Пожалуйста, пополните баланс перед новой записью 💛" : `В календаре пока есть неоплаченные уроки: ${n}. Пожалуйста, пополните баланс перед новой записью 💛`,
      paymentSelection: "Без пополнения баланса можно записаться на один урок. Для нескольких занятий, пожалуйста, пополните баланс 💛",
      paymentDelay: "Уже отправили оплату? Иногда я вижу её чуть позже и ещё не успеваю обновить баланс. Подтвердите ниже — и можно продолжить запись.",
      paymentConfirm: "Я уже оплатил(а) неоплаченные и выбранные уроки",
      paymentReview: "Я проверю оплату и обновлю баланс. Пока уроки останутся отмечены как неоплаченные.",
      paymentThanks: "Спасибо! Можно бронировать 🌷 Я проверю оплату и обновлю баланс.",
      duration: "Длительность урока:",
      min45: "45 минут",
      min60: "60 минут",
      min90: "90 минут",
      selected: "Выбрано уроков:",
      selectedLessons: "Выбранные уроки",
      noSelected: "Нет выбранных уроков.",
      book: "Забронировать уроки",
      checkSaved: "Проверить сохранение",
      retrySame: "Повторить тот же запрос",
      noAccess: "Расписание откроется после одобрения преподавателем.",
      noAccessUntil: (date) => `Бронирование временно недоступно до ${date}.`,
    },
    balance: {
      title: "Баланс уроков",
      sharedWith: "Общий с",
      lessons: "ур.",
      unpaid: "Не оплачено уроков:",
      payFromBalance: "Оплатить с баланса",
      topUp: "Пожалуйста, пополните баланс.",
    },
    lessons: {
      my: "Мои уроки",
      noPlanned: "Нет запланированных уроков",
      partner: "Уроки",
      history: "История уроков",
      myPast: "Мои прошедшие уроки",
      noPast: "Нет уроков за последний месяц",
      noPastTotal: "Нет прошедших уроков за последний месяц",
      show: "Показать",
      hide: "Скрыть",
      paid: "✓ Оплачен",
      unpaid: "○ Не оплачен",
      legendPaid: "Оплачен",
      legendUnpaid: "Не оплачен",
    },
    calendar: {
      previous: "Предыдущий",
      next: "Следующий",
      today: "Сегодня",
      month: "Месяц",
      week: "Неделя",
      day: "День",
      agenda: "Повестка дня",
      date: "Дата",
      time: "Время",
      event: "Событие",
      noEvents: "Нет событий в этом диапазоне.",
      showMore: (total) => `+ ещё ${total}`,
    },
    alerts: {
      bookingSuccess: "Уроки успешно забронированы!",
      bookingUnconfirmed: "Подтверждение брони не получено. Она могла сохраниться. Проверьте результат или повторите тот же запрос — повторная попытка не создаст дубль.",
      googleAdded: " События добавлены в Google Calendar!",
      googlePending: " Изменения в Google Calendar ещё не завершены. Повторите синхронизацию; бронь и баланс сохранены.",
      calendarUpdating: "Расписание обновляется. Новая бронь станет доступна через несколько минут.",
      bookingHorizon: "Можно бронировать на ближайшие 120 дней.",
      notAuthorized: "Ошибка: пользователь не авторизован.",
      pleaseLogin: "Пожалуйста, авторизуйтесь, чтобы забронировать уроки.",
      pastBooking: "Нельзя бронировать уроки в прошлом.",
      timeUnavailable: "В это время бронирование недоступно.",
      alreadyBooked: "Это время уже забронировано",
      dateBlocked: "Извини, в эту дату бронирование недоступно.",
      slotBlocked: "Извини, это время недоступно для бронирования.",
      otherUser: "Вы не можете удалить бронирование другого пользователя.",
      deleted: "Урок успешно удалён. Кредит возвращён (если был списан).",
      deleteError: "Ошибка при удалении урока.",
      bookingError: "Произошла ошибка при бронировании.",
      googleAuthError: "Ошибка авторизации в Google.",
      loggedOut: "Вы вышли из системы.",
      emailVerify: "Пожалуйста, подтвердите ваш email перед входом.",
      registered: "Вы успешно зарегистрированы! Проверьте email для подтверждения.",
      enterEmailReset: "Введите email для сброса пароля.",
      resetSent: "Письмо для сброса пароля отправлено на ",
      paidSuccess: "Успешно оплачено уроков: ",
      payError: "Произошла ошибка при обновлении данных.",
      cancelWarning: "Hola! До урока осталось меньше 24 часов 🙌\n\nЭто время уже зарезервировано только за тобой — предложить его другому ученику я не успею. Поэтому отменить урок сейчас уже нельзя: он засчитывается как проведённый.\n\nПравило одно для всех, без исключений — так честно по отношению ко всем ученикам.",
      noBookingAccess: "Бронирование сейчас недоступно.",
    },
    rules: {
      rulesTitle: "Пара слов о переносах 🙌",
      rulesItem1: "Перенести или отменить урок можно не позже чем за 24 часа. В этот срок я ещё успею предложить слот другому ученику",
      rulesItem2: "Позже 24 часов урок засчитывается как проведённый. Правило одно для всех, без исключений — так честно по отношению ко всем ученикам.",
      rulesCheckbox: "Понятно, правила знаю",
      rulesConfirm: "Забронировать урок",
      rulesLater: "Не сейчас",
    },
    confirm: {
      deleteLesson: "Удалить урок:",
      payCredits: (count) => `Использовать ${count} кредитов с баланса для оплаты прошлых уроков?`,
      yes: "Да",
      cancel: "Отмена",
      ok: "Понятно",
    },
    auth: {
      loginGoogle: "Войти через Google",
      loginEmail: "Войти через Email",
      login: "Войти",
      register: "Зарегистрироваться",
      enterName: "Введите имя",
      enterEmail: "Введите email",
      enterPassword: "Введите пароль",
      forgotPassword: "Забыли пароль?",
      noAccount: "Нет аккаунта? Зарегистрироваться",
      hasAccount: "Уже есть аккаунт? Войти",
    },
    google: {
      addToCalendar: "Добавить уроки в Google Calendar",
      sync: "Обновить Google Calendar",
    },
    portal: {
      badge: "Nuevo 🚀",
      title: "Mi Pasaporte",
      subtitle: "Интерактивные уроки, домашка и Anki-тренажер",
    },
  },

  en: {
    header: {
      title: "Lessons with Xenia",
      subtitle: "Schedule your lessons, manage your timetable, and sync with Google Calendar.",
      login: "Log in",
      logout: "Log out",
    },
    booking: {
      duration: "Lesson duration:",
      paymentTitle: "Just one little step before booking",
      paymentDebt: (n) => `The calendar still shows ${n} unpaid lesson${n === 1 ? '' : 's'}. Please top up your balance before booking again 💛`,
      paymentSelection: "You can book one lesson before topping up. For several lessons, please top up your balance 💛",
      paymentDelay: "Already sent your payment? Sometimes I see it a little later and haven't updated your balance yet. Confirm below to continue booking.",
      paymentConfirm: "I have already paid for the unpaid and selected lessons",
      paymentReview: "I'll check your payment and update your balance. Until then, the lessons will still show as unpaid.",
      paymentThanks: "Thank you! You can book now 🌷 I'll check your payment and update your balance.",
      min45: "45 minutes",
      min60: "60 minutes",
      min90: "90 minutes",
      selected: "Lessons selected:",
      selectedLessons: "Selected lessons",
      noSelected: "No lessons selected.",
      book: "Book lessons",
      checkSaved: "Check booking",
      retrySame: "Retry the same request",
      noAccess: "Your teacher will approve your account before the schedule becomes available.",
      noAccessUntil: (date) => `Booking is currently unavailable until ${date}.`,
    },
    balance: {
      title: "Lesson balance",
      sharedWith: "Shared with",
      lessons: "les.",
      unpaid: "Unpaid lessons:",
      payFromBalance: "Pay from balance",
      topUp: "Please top up your balance.",
    },
    lessons: {
      my: "My lessons",
      noPlanned: "No scheduled lessons",
      partner: "Lessons of",
      history: "Lesson history",
      myPast: "My past lessons",
      noPast: "No lessons in the last month",
      noPastTotal: "No past lessons in the last month",
      show: "Show",
      hide: "Hide",
      paid: "✓ Paid",
      unpaid: "○ Unpaid",
      legendPaid: "Paid",
      legendUnpaid: "Unpaid",
    },
    calendar: {
      previous: "Back",
      next: "Next",
      today: "Today",
      month: "Month",
      week: "Week",
      day: "Day",
      agenda: "Agenda",
      date: "Date",
      time: "Time",
      event: "Event",
      noEvents: "No events in this range.",
      showMore: (total) => `+ ${total} more`,
    },
    alerts: {
      bookingSuccess: "Lessons booked successfully!",
      bookingUnconfirmed: "Booking confirmation was not received. It may have been saved. Check the result or retry the same request — retrying will not create a duplicate.",
      googleAdded: " Events added to Google Calendar!",
      googlePending: " Google Calendar updates are pending. Retry synchronization; your booking and balance are saved.",
      calendarUpdating: "The schedule is being updated. Booking will be available again in a few minutes.",
      bookingHorizon: "You can book within the next 120 days.",
      notAuthorized: "Error: user not authorized.",
      pleaseLogin: "Please log in to book lessons.",
      pastBooking: "Cannot book lessons in the past.",
      timeUnavailable: "This time slot is not available.",
      alreadyBooked: "This time slot is already booked.",
      dateBlocked: "Sorry, this date is not available for booking.",
      slotBlocked: "Sorry, this time slot is not available.",
      otherUser: "You cannot delete another user's booking.",
      deleted: "Lesson deleted. Credit refunded (if applicable).",
      deleteError: "Error deleting lesson.",
      bookingError: "An error occurred while booking.",
      googleAuthError: "Google authorization error.",
      loggedOut: "You have been logged out.",
      emailVerify: "Please verify your email before logging in.",
      registered: "Registration successful! Please check your email for verification.",
      enterEmailReset: "Enter your email to reset password.",
      resetSent: "Password reset email sent to ",
      paidSuccess: "Successfully paid lessons: ",
      payError: "An error occurred while updating data.",
      cancelWarning: "Hey! Less than 24 hours until your lesson 🙌\n\nThis time is already reserved just for you, and I won't be able to offer it to another student. So the lesson can no longer be cancelled: it counts as taken.\n\nSame rule for everyone, no exceptions — that's what keeps it fair for all my students.",
      noBookingAccess: "Booking is not available. Please contact your teacher.",
    },
    rules: {
      rulesTitle: "A quick word about rescheduling 🙌",
      rulesItem1: "You can reschedule or cancel any lesson up to 24 hours before it starts. That gives me time to offer the slot to another student",
      rulesItem2: "Less than 24 hours before, the lesson counts as taken. Same rule for everyone, no exceptions — that's what keeps it fair for all my students.",
      rulesCheckbox: "Got it",
      rulesConfirm: "Book the lesson",
      rulesLater: "Not now",
    },
    confirm: {
      deleteLesson: "Delete lesson:",
      payCredits: (count) => `Use ${count} credits from balance to pay for past lessons?`,
      yes: "Yes",
      cancel: "Cancel",
      ok: "Got it",
    },
    auth: {
      loginGoogle: "Log in with Google",
      loginEmail: "Log in with Email",
      login: "Log in",
      register: "Sign up",
      enterName: "Enter your name",
      enterEmail: "Enter your email",
      enterPassword: "Enter your password",
      forgotPassword: "Forgot password?",
      noAccount: "No account? Sign up",
      hasAccount: "Already have an account? Log in",
    },
    google: {
      addToCalendar: "Add lessons to Google Calendar",
      sync: "Update Google Calendar",
    },
    portal: {
      badge: "New 🚀",
      title: "Mi Pasaporte",
      subtitle: "Interactive lessons, homework & Anki trainer",
    },
  },
};

export default translations;
